import format from 'date-fns/format';
import { ISocketNotificationEvent } from '../../services/websockets/types';
import { IFormattedApiError } from '../api/core/types';
import { IMessage } from './types';

export const messageSerializer = (
  rawMessage: ISocketNotificationEvent,
  myAccountId: string
): IMessage => ({
  id: rawMessage.message.id,
  attributes: {
    isFromMe: false,
    readByMe: false,
    readByOther: true,
    sentAt: rawMessage.date,
    myAccountId: rawMessage.sender_id,
    content: rawMessage.message.content,
    otherAccountId: myAccountId,
  },
});

export const unsentMessageSerializer = (
  senderAboId: string,
  receiverAboId: string,
  content: string,
  error: IFormattedApiError
): IMessageData => {
  const now = new Date();

  return {
    data: {
      id: getUnsentMessageId(now),
      type: 'message',
      attributes: {
        isFromMe: true,
        readByMe: true,
        readByOther: false,
        sentAt: format(now, "yyyy-MM-dd'T'HH:mm:ssXX"),
        myAccountId: senderAboId,
        content,
        otherAccountId: receiverAboId,
        unsent: true,
        unsentError: error,
      },
    },
  };
};

const getUnsentMessageId = (now: Date) => `UNSENT_${now.getTime()}`;

export interface IMessageData {
  data: IMessage;
}
